import sortBy from 'lodash/sortBy';
import { SortOrder } from '../models';
import { regexPatterns } from './regex-patterns';
import { DESC } from './sorting';

export function numericRange(start: number, count: number, startingIndex?: number): number[] {
  startingIndex = startingIndex || 0;
  return Array.apply(startingIndex, Array(count)).map((index: number) => {
    return index + start;
  });
}

export function changeArrayItemIndex(array: any, from: number, to: number) {
  if (to >= array.length) {
    let k = to - array.length;
    while ((k--) + 1) {
      array.push(undefined);
    }
  }
  array.splice(to, 0, array.splice(from, 1)[0]);
  return array;
}

export function sortObjects(targetObjects: any[], sortOrder: SortOrder): any[] {
  let sortedObjects = sortBy(targetObjects, (objects) => objects[sortOrder.key]);

  if (sortOrder.direction === DESC) {
    sortedObjects = sortedObjects.reverse();
  }

  return sortedObjects;
}

export function valueToArray(value: string | any[], delimiter: string |
  // tslint:disable-next-line: align
  RegExp = new RegExp(regexPatterns.arrayDelimiter), nonEmptyValues: boolean = true,
  returnNullIfEmpty: boolean = true): Array<any> | null {
  let arrayToReturn = null;

  if (value) {
    arrayToReturn = typeof value === 'string' ? value.split(delimiter) : value;

    if (nonEmptyValues) {
      arrayToReturn = arrayToReturn.filter(Boolean);
    }

    if (returnNullIfEmpty) {
      return arrayToReturn.length > 0 ? arrayToReturn : null;
    }
  }

  return arrayToReturn;
}
